import { render } from "./StudentPracticumAttendanceDialog.vue?vue&type=template&id=bb0e9e08&scoped=true"
import script from "./StudentPracticumAttendanceDialog.vue?vue&type=script&lang=js"
export * from "./StudentPracticumAttendanceDialog.vue?vue&type=script&lang=js"

import "./StudentPracticumAttendanceDialog.vue?vue&type=style&index=0&id=bb0e9e08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0e9e08"]])

export default __exports__